import client from './client';

export const profileApi = {
  // Get current user profile
  async get() {
    const { data } = await client.get('/api/profile');
    return data;
  },

  // Update profile
  async update(updates) {
    const { data } = await client.patch('/api/profile', updates);
    return data;
  },

  // Get user stats (assigned/reported tasks)
  async getStats() {
    const { data } = await client.get('/api/profile/stats');
    return data;
  },

  // Get tasks assigned to user
  async getTasks(params = {}) {
    const { data } = await client.get('/api/profile/tasks', { params });
    return data;
  },

  // Get user activity feed
  async getActivity(params = {}) {
    const { data } = await client.get('/api/profile/activity', { params });
    return data;
  },

  // Get outstanding pull requests across all accessible projects
  async getOutstandingPRs() {
    const { data } = await client.get('/api/profile/outstanding-prs');
    return data;
  },

  // MCP API Key Management

  // Get MCP key status (not the key itself)
  async getMcpKeyStatus() {
    const { data } = await client.get('/api/profile/mcp-key');
    return data;
  },

  // Generate a new MCP API key (replaces any existing key)
  async generateMcpKey() {
    const { data } = await client.post('/api/profile/mcp-key');
    return data;
  },

  // Revoke MCP API key
  async revokeMcpKey() {
    const { data } = await client.delete('/api/profile/mcp-key');
    return data;
  },

  // Sensu API Key Management

  // Get Sensu key status
  async getSensuKeyStatus() {
    const { data } = await client.get('/api/profile/sensu-key');
    return data;
  },

  // Save Sensu API key
  async saveSensuKey(apiKey) {
    const { data } = await client.put('/api/profile/sensu-key', { apiKey });
    return data;
  },

  // Update Sensu default namespace
  async updateSensuDefaultNamespace(defaultNamespace) {
    const { data } = await client.patch('/api/profile/sensu-key', { defaultNamespace });
    return data;
  },

  // Revoke Sensu API key
  async revokeSensuKey() {
    const { data } = await client.delete('/api/profile/sensu-key');
    return data;
  },

  // SonarQube API Token Management

  async getSonarQubeKeyStatus() {
    const { data } = await client.get('/api/profile/sonarqube-key');
    return data;
  },

  async saveSonarQubeKey(apiToken, baseUrl) {
    const { data } = await client.put('/api/profile/sonarqube-key', { apiToken, baseUrl });
    return data;
  },

  async updateSonarQubeBaseUrl(baseUrl) {
    const { data } = await client.patch('/api/profile/sonarqube-key', { baseUrl });
    return data;
  },

  async revokeSonarQubeKey() {
    const { data } = await client.delete('/api/profile/sonarqube-key');
    return data;
  },

  // Sync API Key Management

  async getSyncKeyStatus() {
    const { data } = await client.get('/api/profile/sync-key');
    return data;
  },

  async generateSyncKey() {
    const { data } = await client.post('/api/profile/sync-key');
    return data;
  },

  async revokeSyncKey() {
    const { data } = await client.delete('/api/profile/sync-key');
    return data;
  },

  // Session Monitor API Key Management

  async getMonitorKeyStatus() {
    const { data } = await client.get('/api/profile/monitor-key');
    return data;
  },

  async generateMonitorKey() {
    const { data } = await client.post('/api/profile/monitor-key');
    return data;
  },

  async revokeMonitorKey() {
    const { data } = await client.delete('/api/profile/monitor-key');
    return data;
  },
};
